<template>
  <el-row>
    <el-row class="entry" v-if="role_id !== 40001">
      <p
        class="title"
      >{{(role_id === 10001 || role_id == 10002) ? $t('teachingTool') : $t('learningTool')}}</p>
      <el-row class="cards">
        <div
          :span="4"
          class="card"
          v-for="(item,index) in computedEntry"
          :style="{'background-image': item.background}"
          @click="router(item.path)"
          :key="index"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('updateTips')"
            placement="right-start"
          >
            <div v-if="item.name === '离线创作工具'" class="new_tips"></div>
          </el-tooltip>
          <div
            class="entry-icon"
            :style="{'background-position': item.position}"
          ></div>
          <p class="item">{{$ct(item.i18n)}}</p>
        </div>
      </el-row>
    </el-row>
    <el-row
      :gutter="30"
      :class="{card_containerXL: role_id === 40001 }"
      class="card_container"
    >
      <el-col :span="12" style="height:100%">
        <p>{{$t('infoTitle')}}</p>
        <el-card style="height:100%">
          <div class="info-card">
            <div
              class="info"
              :class="{info_containerXL: role_id === 40001 }"
              v-for="(item,index) in scoreBoard"
              :key="index"
            >
              <template v-if="item.name !== '上课数'">
                <el-tooltip
                  v-if="item.name === '激活学生数'"
                  :content="$t('infoTips')"
                  placement="top"
                >
                  <span class="class">{{$ct(item.i18n)}}</span>
                </el-tooltip>
                <span v-else class="class">{{$ct(item.i18n)}}</span>
                <el-rate
                  v-model="item.rate"
                  disabled
                  :show-score="false"
                  text-color="#ff9900"
                  :show-text="false"
                  v-if="item.name === '作品平均分' || item.name === '作品最高分'"
                ></el-rate>
                <count-up
                  v-else
                  :id-name="item.name"
                  :end-val="item.value"
                  :color="'black'"
                  countSize="30px"
                  :countWeight="400"
                ></count-up>
                <!-- <span v-if="item.name === '上课数'" style="font-size:12px">根据教师向班级发送课程资料的课程数统计</span> -->
              </template>
              <template v-else>
                <el-tooltip :content="$t('courseCountTips')" placement="top">
                  <span class="class">{{$ct(item.i18n)}}</span>
                </el-tooltip>
                <count-up
                  :id-name="item.name"
                  :end-val="item.value"
                  :color="'black'"
                  countSize="30px"
                  :countWeight="400"
                ></count-up>
              </template>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12" style="height:100%">
        <p>{{$t('blackTitle')}}</p>
        <el-card style="height: 100%">
          <div class="work" v-for="(item,index) in recentList" :key="index">
            <div class="main-content">
              <span>{{item.role_id === 20001 ? $ct('student') : $ct('teacher')}}</span>
              <span class="work-author">{{item.name}}</span>
              {{filterOperation(item.status)}} {{$ct('work')}}
              <span
                class="work-release"
                :class="{'work-no-open': item.work_type === 7 || item.work_status === -99 || item.work_status === -100}"
                @click="checkWorks(item)"
              >{{item.work_name}}</span>
            </div>
            <div class="time">{{formatDate(item.created_time)}}</div>
          </div>
        </el-card>
      </el-col>
      <outline-download-model @closeModel="closeModel" :showModel="showModel"></outline-download-model>
    </el-row>
  </el-row>
</template>

<style lang="scss" scoped>
@import './dashboard';
</style>

<script>
import CountUp from '@/components/countUp'
import { formatDate, workScoreFilter, openLink } from '@/utils/utils'
import outlineDownloadModel from './outlineDownloadModel.vue'
import cloneDeep from 'lodash-es/cloneDeep'
export default {
  name: 'Dashboard',
  inject: ['iPath'],
  components: {
    CountUp,
    outlineDownloadModel
  },
  data() {
    return {
      test: {
        student_num: '150',
        class_num: '200',
        work_num: '300',
        avarage_score: '200',
        high_score: '200'
      },
      recentList: [],
      showModel: false
    }
  },
  methods: {
    filterOperation(id) {
      switch (id) {
        case 1001:
          return this.$t('action.save')
        case 1002:
          return this.$t('action.publish')
        case 2001:
          return this.$t('action.update')
        case 2002:
          return this.$t('action.update')
        case 2003:
          return this.$t('action.update')
        case 4001:
          return this.$t('action.delete')
        case 4002:
          return this.$t('action.delete')
        case 5001:
          return this.$t('action.comment')
      }
    },
    router(path) {
      if (path === 'offlineTool') {
        this.showModel = true
      } else {
        this.$router.push(
          this.iPath({
            name: path
          })
        )
      }
    },
    formatDate(date) {
      return formatDate(date)
    },
    closeModel() {
      this.showModel = false
    },
    async checkWorks(work) {
      const type = work.work_type
      if (work.work_status === 1) {
        if (type === 1 || type === 4 || type === 6 || type === 0) {
          const newPage = window.open()
          openLink(`${CONFIG.ide}/old/we/${work.work_id}`, newPage)
        } else if (type === 5) {
          const newPage = window.open()
          openLink(`${CONFIG.box}/w/${work.work_id}`, newPage)
        }
      } else {
        const newPage = window.open()
        openLink(`${CONFIG.lab}/work/${work.work_id}`, newPage)
      }
    }
  },
  computed: {
    // 入口
    entry() {
      return this.$store.state.user.entry
    },

    computedEntry() {
      return this.entry.filter(v => {
        // if (v.path === 'offlineTool') {
        //   return ['Win7', 'Win10', 'WinXP'].includes(this.$store.state.os)
        // }
        return v.path !== 'help'
      })
    },

    scoreBoard() {
      const data = cloneDeep(this.$store.state.user.scoreBoard)
      data.forEach(value => {
        value.rate = workScoreFilter(value.value)
      })
      return data
    },
    role_id() {
      // FIXME: 解决eslint的问题
      /* eslint-disable */
      this.$store.dispatch('getRecentRecord').then(data => {
        this.recentList = data
      })
      /* eslint-enable */
      this.$store.dispatch('getStatistic')
      return this.$store.state.user.role_id
    }
  }
}
</script>
<i18n lang="yaml">
en:
  teachingTool: Teaching Tool
  learningTool: Learning Tool
  infoTitle: Info
  blackTitle: Dynamic
  infoTips: The first time a student successfully enters the “future classroom” is activated.
  updateTips: Version updated Please download the latest version
  courseCountTips: According to the statistics of the number of courses that teachers send course materials to the class
  action:
    save: saved
    publish: published
    update: updated
    delete: deleted
    comment: commented
zh-CN:
  teachingTool: 教学工具
  learningTool: 学习工具
  infoTitle: 信息栏
  blackTitle: 小黑板
  infoTips: 学生首次成功进入“未来教室”即为激活状态
  updateTips: 版本已更新 请下载最新版本
  courseCountTips: 根据教师向班级发送课程资料的课程数统计
  action:
    save: 保存了
    publish: 发布了
    update: 更新了
    delete: 删除了
    comment: 评价了
zh-TW:
  teachingTool: 教學工具
  learningTool: 學習工具
  infoTitle: 信息欄
  blackTitle: 小黑板
  infoTips: 學生首次成功進入“未來教室”即為激活狀態
  updateTips: 版本已更新 請下載最新版本
  courseCountTips: 根據教師向班級發送課程資料的課程數統計
  action:
    save: 保存了
    publish: 發布了
    update: 更新了
    delete: 删除了
    comment: 评价了
it:
  teachingTool: Strumento didattico
  learningTool: Strumento di apprendimento
  infoTitle: Info
  blackTitle: Dinamica
  infoTips: La prima volta che uno studente entra con successo nella "Future Classroom", viene attivato l'account dello studente.
  updateTips: Versione aggiornata, Scarica la versione più recente
  courseCountTips: In base ai dati statistici sul numero di corsi per i quali gli insegnanti inviano i materiali del corso alla classe
  action:
    save: salvato
    publish: pubblicato
    update: aggiornato
    delete: cancellato
    comment: commentato
id:
  teachingTool: Alat pengajaran
  learningTool: Alat pembelajaran
  infoTitle: Informasi
  blackTitle: Pembaruan
  infoTips: Pertama kali siswa berhasil masuk “kelas masa depan” telah diaktifkan.
  updateTips: Silahkan unduh versi terbaru
  courseCountTips: Menurut statistik jumlah kursus yang telah dikirim guru ke kelas
  action:
    save: Tersimpan
    publish: diterbitkan
    update: diperbarui
    delete: dihapus
    comment: komentar
</i18n>
